import React, { Fragment, useState, useEffect } from 'react'
import { Container, Card, Grid, CardContent, Typography } from '@material-ui/core';
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import CKEditor from "react-ckeditor-component";
import { Settings, Alerts } from '../../../helpers';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Banner",
        page_path: "/app/profile",
        icon: "",
    }
]
const BannerUpdate = () => {

    const [bannerContent, setBannerContent] = useState('');
    const [bannerImage, setBannerImage] = useState('');
    const [linkLabel, setLinkLabel] = useState('');
    const [linkUrl, setLinkUrl] = useState('');


    const getData = async () => {
        let resp = await Settings.getHomeBanner();
        if (resp && resp.status) {
            setBannerContent(resp.banner.content);
            setBannerImage(resp.banner.image);
            setLinkLabel(resp.banner.link_label);
            setLinkUrl(resp.banner.link_url);
        }
    }
    useEffect(() => {
        getData();
    }, [])


    const handleChangeContent = (evt) => {
        var newContent = evt.editor.getData();
        setBannerContent(newContent);
    }
    const handleChangeImage = (e)=>{
        setBannerImage(e.target.files[0])
    }
    const handleChangeLinkLabel = (e)=>{
        setLinkLabel(e.target.value)
    }
    const handleChangeLinkUrl = (e)=>{
        setLinkUrl(e.target.value)
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        let formData = new FormData();    

        formData.append('content', bannerContent);
        formData.append('image', bannerImage);
        formData.append('link_label', linkLabel);
        formData.append('link_url', linkUrl);
        let resp = await Settings.updateHomeBanner(formData);
        if(resp){
            if(resp.status){
                Alerts.alertMessage(resp.message, '', 'success')
                setTimeout(function(){
                    window.location.reload();
                 }, 3000);
              }else{
                Alerts.alertMessage(resp.message, '', 'danger')
              }
        }

    }
    return (
        <Fragment>
            <Breadcumb items={BreadcrumbData} />
            <div className="page-wrapper mt20">
                <Container >
                    <Card className="card">
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item lg={6} sm={6}>
                                    <Typography variant="h5" gutterBottom>
                                        Home Banner
                                    </Typography>

                                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                                        <div className='form-group'>
                                            <label>Banner content</label>
                                            <CKEditor
                                                activeClass="p10"
                                                content={bannerContent}
                                                events={{
                                                    "afterPaste": handleChangeContent,
                                                    "change": handleChangeContent
                                                }}
                                            />
                                        </div>
                                        <div className='form-group'>
                                            <label>Change Image</label>
                                            <input type="file" className='form-control' onChange={handleChangeImage}/>
                                        </div>
                                        <div className='form-group'>
                                            <label>Link Label</label>
                                            <input type="text" className='form-control' value={linkLabel} onChange={handleChangeLinkLabel}/>
                                        </div>
                                        <div className='form-group'>
                                            <label>Link Url</label>
                                            <input type="text" className='form-control' value={linkUrl} onChange={handleChangeLinkUrl}/>
                                        </div>
                                        <div className='form-group'>
                                            <button type="submit" className='btn btn-primary'>Update Now</button>
                                        </div> </form>

                                </Grid>
                                <Grid item lg={6} sm={6}>

                                    <div className='form-group'>
                                        <label>Banner Image</label>
                                        <img src={bannerImage} alt='' style={{ maxWidth: 400, display: 'block' }} />
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </div>
        </Fragment>

    )
}

export default BannerUpdate